var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermitType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66663 11.9998C6.87563 10.6974 9.11129 10.636 10.3333 11.9998M9.29369 7.99984C9.29369 8.73624 8.71249 9.33317 7.99556 9.33317C7.27863 9.33317 6.69743 8.73624 6.69743 7.99984C6.69743 7.26344 7.27863 6.6665 7.99556 6.6665C8.71249 6.6665 9.29369 7.26344 9.29369 7.99984Z",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 2.66797C4.57045 2.67454 3.62738 2.73618 3.01679 3.31464C2.33337 3.96208 2.33337 5.00414 2.33337 7.08827V10.2461C2.33337 12.3303 2.33337 13.3723 3.01679 14.0197C3.70021 14.6672 4.80015 14.6672 7.00004 14.6672H9.00004C11.1999 14.6672 12.2998 14.6672 12.9833 14.0197C13.6667 13.3723 13.6667 12.3303 13.6667 10.2461V7.08827C13.6667 5.00414 13.6667 3.96208 12.9833 3.31464C12.3727 2.73618 11.4296 2.67454 9.66671 2.66797",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51481 2.42125C6.57877 2.14471 6.61076 2.00644 6.67217 1.89352C6.81531 1.63047 7.07924 1.43715 7.39431 1.36463C7.52957 1.3335 7.68644 1.3335 8.00004 1.3335C8.31364 1.3335 8.47051 1.3335 8.60577 1.36463C8.92084 1.43715 9.18477 1.63046 9.32791 1.89352C9.38931 2.00644 9.42131 2.14471 9.48524 2.42125L9.54077 2.66134C9.65424 3.15179 9.71097 3.39702 9.62537 3.58566C9.56997 3.70783 9.47551 3.81244 9.35404 3.88624C9.16644 4.00016 8.88831 4.00016 8.33211 4.00016H7.66797C7.11177 4.00016 6.83364 4.00016 6.64605 3.88624C6.52455 3.81244 6.43011 3.70783 6.37469 3.58566C6.28911 3.39702 6.34583 3.15179 6.45928 2.66134L6.51481 2.42125Z",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermitType);
export default __webpack_public_path__ + "static/media/permit_type.1afe668412029a4ab95b3716343fd60d.svg";
export { ForwardRef as ReactComponent };